import gql from 'graphql-tag'
export interface RequestPasswordLinkInput {
  email: string
}

export interface RequestPasswordLink {
  requestPasswordLink: boolean
}

export default gql`
  mutation RequestPasswordLink($email: String!) {
    requestPasswordLink(email: $email)
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/requestPasswordLink.tsx